export default __webpack_public_path__ + "static/consumer-protection-852839587ccfc0c0ad070f703a6b0b18.svg";